import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";
import {Apollo} from "apollo-angular";
import {firstValueFrom, Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import { getAditionals, getAhorros, getAmortizacion, getAsientos, getCuenta, getCuentasProm, getDetalleCuenta, getDetalleVarTemp, getEvaluaciones, getGAPRiesgos, getInversion1, getInversiones, getLiquidez, getRCL, getVariable, getVarProm, getVarTemp, getVarTempProm, postAdicionales } from "./query";
import { messages } from '../../elements/funciones/mensajes';
import { getDetalleEvaluacionCuenta } from '../financiero/catalogo-cuentas/querys';

@Injectable({
  providedIn: 'root'
})
export class ServiciosRiegosService {
 private readonly apiURL = environment.api_aleemaRiesgosGeneralRest;
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersRes = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private readonly cookies: CookieService,
    private readonly apollo: Apollo,
    private http: HttpClient,
  ) { }

  /**
   * Obtiene las evaluaciones disponibles para la plantilla de Alerta Temprana
   * @param idPlantilla ID de la plantilla
   * @returns Datos de evaluaciones
   */
  async getEvaluaciones(idPlantilla: number = 7) {
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers },
          variables: { idPlantilla }
        }).valueChanges
      );
      return data;
    }catch(err){
      messages.errorMessageGraph(err);
      return ;
    }
  }

  /**
  * Obtiene los detalles de una cuenta
  * @param evaluacion es el ID del periodo que se quiere continuar
  * @param el ID de la cuenta que se va a consultar
  * @returns se regresa el valor de las cuentas 
  */
  async getDetalleCuenta(evaluacion, cuenta){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleCuenta,
          context: { headers: this.headers },
          variables: { idEvaluacion: evaluacion, idCuenta: cuenta, params: {
            idEvaluacion: evaluacion,
            idCuenta: cuenta
          }}
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
   * Obtiene los valores de todas las cuentas
   * @param evaluacion el Id de la evaluacion a consultar
   * @returns 
   */
  async getDetalleCuentas(evaluacion){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleEvaluacionCuenta,
          context: { headers: this.headers },
          variables: { idEvaluacion: evaluacion }
        }).valueChanges
      )

      return data.detalleEvaluacionCuentas;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene las cuentas
  * @param cuenta es el ID de la cuenta
  * @param idPlantilla es el ID de la plantilla que se va a consultar
  * @returns se regresa el valor de las cuentas 
  */
  async getCuenta(cuenta, idPlantilla){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuenta,
          context: { headers: this.headers },
          variables: { cuentaId: cuenta, idPlantilla: idPlantilla, params: {
            id: cuenta, idPlantilla: idPlantilla
          } }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene una variable temporal
  * @param evaluacion es el ID del periodo
  * @param variableTemp es el ID de la variable temporal
  * @returns se regresa el valor de la variable temporal
  */
  async getDetalleVarTemp(evaluacion, variableTemp){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getDetalleVarTemp,
          context: { headers: this.headers },
          variables: { idEvaluacion: evaluacion, idVarTemp: variableTemp, }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene ulas variables temporales
  * @param cuenta es el ID de la cuenta
  * @param idPlantilla es el ID de la plantilla que se va a consultar
  * @returns se regresa el valor de las cuentas 
  */
  async getVarTemp(cuenta, idPlantilla){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarTemp,
          context: { headers: this.headers },
          variables: { idPlantilla: idPlantilla, varTempId: cuenta,  params: {
            id: cuenta, idPlantilla: idPlantilla
          } }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene el valor de una variable del periodo mandado
  * @param evaluacion es el id de l periodo a consultar
  * @param variable es el id de la variable que se desea consultar
  * @return regresa el valor de la variable
  */
  async getVariable(evaluacion, variable){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVariable,
          context: { headers: this.headers },
          variables: { idEvaluacion: evaluacion, idVariable: variable, }
        }).valueChanges
      );

      return data;
    }catch(err){
      messages.errorMessageGraph(err)
    }
    
  }

  /**
  * Obtiene los ahorros
  * @param periodo es el ID del periodo
  * @returns se regresa el valor de las cuentas 
  */
  async getAhorros(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getAhorros,
          context: { headers: this.headers },
          variables: { periodo: periodo }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene la amortización
  * @param periodo es el ID del periodo
  * @returns se regresa el valor de las cuentas 
  */
  async getAmortizacion(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getAmortizacion,
          context: { headers: this.headers },
          variables: { periodo: periodo }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene tres valores de una cuenta de tres periodos
  * @param variables son las variables que se requieren
  * @returns se regresa el valor de las cuentas 
  */
  async getCuentasPromedio(variables){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getCuentasProm,
          context: { headers: this.headers },
          variables: variables
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene tres valores de una variable temporal de tres periodos
  * @param variables son las variables que se requieren
  * @returns se regresa el valor de las cuentas 
  */
  async getVarTempPromedio(variables){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarTempProm,
          context: { headers: this.headers },
          variables: variables
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene tres valores de una variable de tres periodos
  * @param variables son las variables que se requieren
  * @returns se regresa el valor de las cuentas 
  */
  async getVarPromedio(variables){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getVarProm,
          context: { headers: this.headers },
          variables: variables
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los datos de asientos
  * @param periodo es el ID del periodo
  * @returns se regresa el valor de las cuentas 
  */
  async getAsientos(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getAsientos,
          context: { headers: this.headers },
          variables: { periodo: periodo }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los adicionales
  * @param periodo es el ID del periodo
  * @param editable es la subcolección que se ocupa
  * @returns se regresa el valor de las cuentas 
  */
  async getAditionals(periodo, editable){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getAditionals,
          context: { headers: this.headers },
          variables: { periodo: periodo, subColeccion: editable},
          fetchPolicy: 'no-cache',
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los datos de inversiones
  * @param periodo es el ID del periodo
  * @returns se regresa el valor de las Inversiones 
  */
  async getInversiones(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getInversiones,
          context: { headers: this.headers },
          variables: { periodo: periodo }
        }).valueChanges
      )

      return data
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los datos de inversiones
  * @param periodo es el ID del periodo
  * @returns se regresa el valor de las Inversiones 
  */
  async getInversiones1(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getInversion1,
          context: { headers: this.headers },
          variables: { periodo: periodo }
        }).valueChanges
      )

      return data;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los datos de Liquides
  * @param Variable que representa los periodos
  * @returns Regresa los valores de liquidez
  */
  async getLiquidez(periodo){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
          query: getLiquidez,
          context: { headers: this.headers},
          variables: { periodo: periodo }
        }).valueChanges
      );

      return data;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }

  /**
  * Obtiene los datos de inversiones
  * @param variables son los adicionales a postear
  * @returns se regresa el valor de las cuentas 
  */
  async postAdicionales(variables){
    try{
      await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgos).mutate({
          mutation: postAdicionales,
          context: {headers: this.headers},
          variables: JSON.parse(variables)
        })
      )

    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /**
   * 
   * @param idInstitucion id de la institucion del administrador
   * @param mes numero de mes a consultar
   * @param anio numero año a consultar
   */
  async getGAPRiesgos(idInstitucion:string, mes: number, anio:number){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
          query: getGAPRiesgos,
          context: { headers: this.headers },
          variables: { idInstitucion: idInstitucion, mes: mes, anio: anio },
          fetchPolicy: 'no-cache',
        }).valueChanges
      )
      return data.getGap;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /**
   * Postear las variable editables 
   * @param p {idInstitucion: string, anio: number, mes: number, nombre:string}
   * @param bandas arreglo de objetos {label:string, valor: number, order: number}
   * @returns 
   */
  public postVariblesGapRiesgos(p:{idInstitucion:string, anio:number, mes:number, nombre:string},
    bandas: {label:string, valor: number, order: number}[]): Observable<any>{
    const v = {
      idInstitucion: p.idInstitucion,
      anio: p.anio,
      mes: p.mes,
      nombre: p.nombre,
      bandas: bandas
    }
    const body = JSON.stringify(v);
    const apiURL = `${this.apiURL}gap/variable`;
    return this.http.post(`${apiURL}`, body, { headers: this.headersRes});
  }

  async getRCL(idInstitucion:string, mes: number, anio:number){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
          query: getRCL,
          context: { headers: this.headers },
          variables: { idInstitucion: idInstitucion, mes: mes, anio: anio }
        }).valueChanges
      )
      return data.getRCL;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
}
